import { useState } from "react";

import { Carousel } from "react-responsive-carousel";

import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader

import { IFeedEntry } from "../../store/FeedEntry";
interface IVideoCardProps {
  feedEntry: IFeedEntry;
}

interface ImageWithHeight {
  height: number;
  image: string;
}

function VideoCard({ feedEntry }: IVideoCardProps) {
  const imagesWithHeight = (images: string[]): ImageWithHeight[] => {
    return images.map((img) => {
      return {
        image: img,
        height: 0,
      };
    });
  };

  const images_in = feedEntry?.images || [];
  console.log(feedEntry);
  const [images, setImages] = useState(imagesWithHeight(images_in));

  const compareImageHeights = (a: ImageWithHeight, b: ImageWithHeight) => {
    return b.height - a.height;
  };

  const addImageHeight = (
    images: ImageWithHeight[],
    currentSrc: string,
    height: number
  ) => {
    console.log("Adding Image Height");
    let _images = images.map((img: ImageWithHeight) => {
      if (img.image === currentSrc) {
        return {
          image: img.image,
          height: height,
        };
      }
      return img;
    });
    _images.sort(compareImageHeights);
    return _images;
  };

  const onImgLoad = (target: any) => {
    if (images.length <= 1) return;
    const _images = addImageHeight(
      images,
      target.target.currentSrc,
      target.target.offsetHeight
    );
    if (_images !== images) {
      setImages(_images);
    }
  };

  return (
    <Carousel
      centerMode={true}
      centerSlidePercentage={100}
      showThumbs={false}
      showStatus={false}
    >
      {images.map((img: ImageWithHeight, i: number) => {
        return (
          <figure key={i} style={{ backgroundColor: "black" }}>
            <img
              onLoad={onImgLoad}
              src={img.image}
              alt={feedEntry.title}
              style={{
                width: "auto",
                height: "auto",
                maxHeight: "80vh",
              }}
            />
          </figure>
        );
      })}
    </Carousel>
  );
}

export default VideoCard;
// max-md:fixed max-md:h-5/6
// max-md:fixed max-md:h-1/5 bottom-0
